$(document).ready(function() {
  $('.custom_buy_btn, .comparison-button-template--16940627361907__ss_comparison_table_10_TRqi6i').on('click', function() {
    $('button.product-form__submit.button.button--full-width').trigger('click');
  });
});


$(document).ready(function () {
    $(".new-landing-page  .product-form__submit").click(function () {
        setTimeout(function () {
            window.location.href = "/checkout"; // Update with your actual checkout URL
        }, 2000); // 2000ms = 2s delay
    });
});
$(document).ready(function() {
  $('section.custom_star_reviews .swiper-container .bottom_button .add_to_cart, .custom_html_liquid .custom_html_wrap span.bottom_text').on('click', function() {
    $('.new-landing-page  .product-form__submit').trigger('click');
  });
});





document.querySelectorAll('.custom_comparison_table .bottom_btn, .custom_how_to_use .image_content_wrap .number_content_block .bottom_btn, section.custom_star_reviews .swiper-container .bottom_button .learn_more, .custom_image_video_slider .swiper-container .bottom_button, .custom_product_feature .btn_wrapper, a.button.button--medium, section.custom_text_button .wrapper a.section_button, section.custom_header .wrapper .header_btn.save_btn, .custom_faq_section .first_side_faq-anchor, .custom_banner_section .page-width.banner_content .content_wrap .banner_bnt').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault(); // Prevent the default link behavior
    const target = document.querySelector('.featured-product.product');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});


// bundle js
$(function() {
          setTimeout(function () {
$('.quantity__input[type=number]').val('1');
          },500);
});
$('.kaching-bundles__bar').on('click', function() {
  // Remove 'active' from all
  $('.kaching-bundles__bar').removeClass('active');
  
  // Add 'active' to the clicked one
  $(this).addClass('active');

  // Get the bundle quantity from the clicked item
  var qty = $(this).find('.kaching-bundles__bar-wrapper').attr('bundle_qty');

  // Set the value in the quantity input
  $('.quantity__input[type=number]').val(qty);
});
